import axios from "axios";
import { IBookingsApiFilter } from "../types";

export interface IGetBookingsCountParams {
    filters?: IBookingsApiFilter
}

export const getBookingsCount = async (params: IGetBookingsCountParams): Promise<number> => {
    const response = await axios.post('/booking/search/counter', params);
    return response.data;
};

export default getBookingsCount;